#import "../../overview/graphql/fragments/report-view-fragment.graphql"

mutation TrackReportView($input: TrackReportViewInput!) {
    trackReportView(input: $input) {
        recentlyViewedReports {
            ...ReportViewFields
        }
    }
}
